/* unplugin-vue-components disabled */import { render } from "./TranslateX.vue?vue&type=template&id=6e175bf6&scoped=true"
import script from "./TranslateX.vue?vue&type=script&lang=js"
export * from "./TranslateX.vue?vue&type=script&lang=js"

import "./TranslateX.vue?vue&type=style&index=0&id=6e175bf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e175bf6"]])

export default __exports__